import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../api';
import '../styles/AddVenue.css';

function AddVenue() {
  const [newVenueName, setVenueName] = useState('');
  const [newVenueAddress, setVenueAddress] = useState('');
  const [status, setStatus] = useState(null);      // null | 'success' | 'error'
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const { user_id } = useParams();

  const handleAddVenue = async () => {
    setStatus(null);

    try {
      // 1) Add the new venue
      const { data: addData } = await api.post(
        '/add_venue/',
        {
          venue_name: newVenueName,
          venue_address: newVenueAddress
        },
        { withCredentials: true }
      );

      if (addData.status !== 'success') {
        throw new Error(addData.status || 'Server rejected add_venue');
      }

      // 2) Auto-select it for the user
      await api.post(
        '/select_venue/',
        {},
        {
          params: {
            user_id,
            venue_name: newVenueName
          },
          withCredentials: true
        }
      );

      setStatus('success');
      setMessage(
        "Thanks! Your venue is recorded and pending review. We'll notify you when it's live—meanwhile you can go back to your dashboard."
      );
    } catch (err) {
      console.error(err);
      setStatus('error');
      setMessage(
        'Oops—could not record your venue. Please check your network or try again later.'
      );
    }
  };

  // after successful add, show confirmation & return to dashboard
  if (status === 'success') {
    return (
      <div className="add-venue-container">
        <div className="logo">BestDay2Marry</div>
        <h1>Venue Submitted</h1>
        <p>{message}</p>
        <button
          className="medium-button"
          onClick={() => navigate(`/dashboard/${user_id}`)}
        >
          Return to Dashboard
        </button>
      </div>
    );
  }

  // default form
  return (
    <div className="add-venue-body">
      <div className="add-venue-container">
        <div className="logo">BestDay2Marry</div>
        <h1>Add Your Venue</h1>

        <div className="form-group">
          <input
            type="text"
            placeholder="Venue name"
            value={newVenueName}
            onChange={(e) => setVenueName(e.target.value)}
          />
        </div>

        <div className="form-group">
          <input
            type="text"
            placeholder="Venue address"
            value={newVenueAddress}
            onChange={(e) => setVenueAddress(e.target.value)}
          />
        </div>

        {status === 'error' && <p className="error-message">{message}</p>}

        <button className="submit" onClick={handleAddVenue}>
          Submit
        </button>
        <button className="back-button" onClick={() => navigate(-1)}>
          Back
        </button>
      </div>
    </div>
  );
}

export default AddVenue;